// extracted by mini-css-extract-plugin
export var fadeInOut = "_2u-3";
export var icon = "_2u-4";
export var savedIndicator = "_2u-2";
export var savingIndicator = "_2u-0";
export var spin = "_2u-1";